import React, { FC } from 'react';
import { TypeReplacementPartsProductsPageData } from '@/pages/[locale]/account/replacement-parts';
import { TypeReplacementPartsFields } from '@/core/generated-types';
import { Link } from '@/navigation';
import { HeaderText } from '@/components/ui';
import { HeaderSize } from '@/components/ui/HeaderText';
import Image from 'next/image';
import { getAssetForProduct } from '@/lib/api/productCatalog/helpers';
import { setLocalStorage } from '@/utils/localStorage';

interface ReplacementPartsProductsProps extends TypeReplacementPartsFields {
  data: TypeReplacementPartsProductsPageData;
}

const ReplacementPartsProducts: FC<ReplacementPartsProductsProps> = (props) => {
  const {
    data: { products },
    title,
    description,
  } = props;

  return (
    <>
      <div className="mb-10 text-center md:text-left">
        {title && (
          <HeaderText size={HeaderSize.H2} text={title} classes="mb-6" />
        )}
        {description && <p className="text-lg leading-6">{description}</p>}
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {products?.map(({ product, contentfulProduct }) => {
          const {
            name,
            external_id,
            anchor,
            display_age_range: displayAgeRange,
            metadata,
          } = product;
          const { ageDescription } = contentfulProduct?.fields;
          const asset = getAssetForProduct(product);
          const ageRange =
            metadata.data?.age_tagline || ageDescription || displayAgeRange;
          return (
            <Link
              key={external_id}
              href={`/account/replacement-parts/${anchor}`}
              className="hover:text-indigo-dark"
              onClick={() =>
                setLocalStorage('replacementPartsProduct', product)
              }
            >
              {asset ? (
                <div className="relative bg-khaki-tint">
                  <Image
                    src={asset.uri}
                    alt={asset.alt_text || `${name} image`}
                    height={240}
                    width={320}
                    className="mx-auto h-[240px] object-contain"
                  />
                </div>
              ) : null}
              <div className="mt-3">
                <p className="text-lg font-bold">{name}</p>
                <p>{ageRange}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default ReplacementPartsProducts;
